import React, { createContext, useContext, useMemo } from 'react';
import { useAuthContext } from './AuthContext';
import { useSubscriptions } from '../hooks/useSubscriptions';

const SubscriptionContext = createContext(null);

export function SubscriptionProvider({ children }) {
  const { isLoggedIn } = useAuthContext();
  const subscriptionState = useSubscriptions(isLoggedIn);
  const value = useMemo(() => subscriptionState, [subscriptionState]);

  return (
    <SubscriptionContext.Provider value={value}>{children}</SubscriptionContext.Provider>
  );
}

export function useSubscriptionContext() {
  const ctx = useContext(SubscriptionContext);
  if (!ctx) {
    throw new Error('useSubscriptionContext must be used within a SubscriptionProvider');
  }
  return ctx;
}
